module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5f6e6debfc04be0836d42b45ea85a6bb.png";